import { render, staticRenderFns } from "./x-input.vue?vue&type=template&id=149bd23d&scoped=true&"
import script from "./x-input.vue?vue&type=script&lang=js&"
export * from "./x-input.vue?vue&type=script&lang=js&"
import style0 from "./x-input.vue?vue&type=style&index=0&id=149bd23d&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149bd23d",
  null
  
)

export default component.exports